export default ({ hour, minute }) =>
  `${hour === 0 ? '00' : hour}:${
    minute === 0 ? '00' : minute < 10 ? `0${minute}` : minute
  }`
